import { DocumentData } from 'firebase/firestore';
import { IRecordingWithAuthor, IBaseRecording } from '../../types';
import { IRecording } from '../../types/Recording';

/**
 * Recording-specific types and interfaces
 */

export interface ModerationResult {
  isAppropriate: boolean;
  flaggedCategories: string[];
  sentiment?: any;
  entities?: any[];
  tokens?: any[];
  categories?: any[];
  flaggedPhrases?: string[];
}

export interface IRecordingWithModerationInfo extends IRecordingWithAuthor {
  moderationResult?: ModerationResult;
}

/**
 * Helper function to check if submissions-responses tutorial has been started
 */
export function hasSubmissionsResponsesTutorialStarted(): boolean {
  try {
    const tutorialFlow = localStorage.getItem('demo_tutorial_flow');
    const completedSteps = localStorage.getItem('demo_tutorial_progress');
    const steps = completedSteps ? JSON.parse(completedSteps) : [];
    
    // Check if tutorial flow is active or if any steps have been completed
    const isStarted = tutorialFlow === 'submissions-responses-tutorial' || 
           steps.includes('submissions-responses-welcome') ||
           steps.includes('submissions-responses-welcome-split') ||
           steps.includes('submissions-responses-tabs') ||
           steps.includes('submissions-responses-tabs-split');
    
    return isStarted;
  } catch (error) {
    return false;
  }
}
